// extracted by mini-css-extract-plugin
export default {"sesion":"Sesion_sesion__DsKBu"};